import React from 'react';

const AdminPage = () => {
  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg-secondary)', padding: '2rem 0' }}>
      <div className="container">
        <div className="card" style={{ padding: '2rem' }}>
          <h1 style={{ marginBottom: '2rem' }}>🔧 Admin Panel</h1>
          <p style={{ color: 'var(--text-secondary)' }}>
            Word pack management and admin features coming soon...
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdminPage;
